import global, { types as globalTypes } from "./global";
import mode, { types as modeTypes } from "./mode";

export const types = {
    GLOBAL: globalTypes,
    MODE: modeTypes,
};

export default {
    global,
    mode,
};
